import PropTypes from 'prop-types';
import React from 'react';
import { Iterable } from 'immutable';
import { compose } from 'recompose';
import ReactInterval from 'react-interval';

import MainPage from '../components/MainPage.react';
import bindReduceStore from '../components/hocs/bindReduceStore.react';
import withFilter from '../components/hocs/withFilter.react';
import JobFilter from '../components/filters/JobFilter.react';
import JobTable from '../components/JobTable.react';

import JobUsersStore from '../stores/JobUsersStore';
import JobActions from '../actions/JobActions';

import JobStore from '../stores/JobStore';
import { JobFilters, makeJobFilter } from '../util/Filters';

class Jobs extends React.Component {
  constructor(props) {
    super(props);
    this.selectJob = this.selectJob.bind(this);
  }

  componentDidMount() {
    setTimeout(() => JobActions.debouncedLoadAllJobs());
  }

  selectJob(job) {
    const { router } = this.context;
    if (job.id) {
      router.push(`/jobs/${job.id}`);
    }
  }

  render() {
    return (
      <MainPage>
        <ReactInterval
          timeout={10000}
          enabled
          callback={() => JobActions.debouncedLoadAllJobs()}
        />
        <JobFilter
          filters={this.props.filters}
          updateFilter={this.props.updateFilter}
          allOwners={this.props.owners}
        />
        <JobTable
          jobs={this.props.filteredObjects}
          onSelect={this.selectJob}
          selectedId={this.props.params.jobId}
        />
        {this.props.children}
      </MainPage>
    );
  }
}

export default compose(
  bindReduceStore(JobUsersStore, 'owners',
    owners => owners.map(email => ({ label: email, value: email })),
  ),
  withFilter(JobStore, new JobFilters(), makeJobFilter),
)(Jobs);

Jobs.propTypes = {
  params: PropTypes.object,
  filters: PropTypes.instanceOf(JobFilters),
  updateFilter: PropTypes.func,
  filteredObjects: PropTypes.instanceOf(Iterable),
  owners: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  }),
};

Jobs.contextTypes = {
  router: PropTypes.object,
};
